import type { LDContext } from "launchdarkly-react-client-sdk";

import type { UserDTO } from "../../common/types/UserDTO";

function toUserContext(userData?: UserDTO): LDContext {
  if (!userData) {
    return { kind: "user", anonymous: true };
  }

  return {
    kind: "user",
    key: userData.id.toString(),
    email: userData.email,
    roles: userData.roles,
    accountId: userData.accountId,
  };
}

export default toUserContext;
